<template>
    <div class="box-title">
        <div class="title">{{ title }}</div>
        <div class="sub-title">{{ subtitle }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss" scoped>
.box-title {
    display: flex;
    align-items: flex-end;
    line-height: 1;
    .title {
        font-size: 46px;
    }
    .sub-title {
        font-size: 24px;
        margin-left: 20px;
    }
}
</style>